import template from './app-reviews.comp.html'

export const translations = [
  [
    'Super App!',
    'Super App!',
  ],
  [
    'Your app is awesome to track who has spend how much money for the household!',
    'Eure App is super beim Nachvollziehen wer wie viel Geld für die WG ausgelegt hat!',
  ],
  [
    'Also for families, not just for flat shares',
    'Auch für Familien, nicht nur für WGs',
  ],
  [
    `With this app it's easy to distribute the chores in a family. With the collected points we see, who has done how much. There is a bonus for the points. Suddenly the kids are hard-working!`,
    'Mit dieser App lässt sich die Hausarbeit in einer Familie gut verteilen. Mit den gesammelten Punkten sehen wir, wieviel wer was gemacht. Es gibt für die Punkte einen Taschengeld Bonus. Plötzlich sind die Kinder sehr fleißig!',
  ],
  [
    'Great app - we like it',
    'Tolles Programm – gefällt uns super.',
  ],
  [
    'We have ordered the premium version right away',
    'Haben gleich die Premium Version bestellt!',
  ],
  [
    'Just cool',
    'Einfach cool',
  ],
  [
    `We are using this app from the very beginning and we love it. Put an item on the list and everyone knows immediatey what's missing. Who doing the shopping checks it and done. We even use it for our chores.`,
    'Wir nutzen die App von Anfang an und lieben Sie. Liste erstellen und jeder weiß direkt was fehlt. Wer einkauft hakt ab und fertig. Wir machen sogar unseren Haushalt damit.',
  ],
  [
    'Top! Perfect for couples, too',
    'Top! Perfekt auch für Paare',
  ],
  [
    'We simply add every expense in the app and at the end of the month we do the settlement, super uncomplicated. This app is a real simplification for every day life.',
    'Wir geben jede Ausgabe einfach in die App ein und am Ende des Monats rechnen wir ab, super unkompliziert. Eine echte vereinfachung des Alltags diese App!',
  ],
]

export default angular.module('flatastic.component.app-reviews', [])

.component('appReviews', {
  controller: [function() {
    this.appReviews = [
      {
        name: 'Samantha B.',
        title: translations[0][0],
        description: translations[1][0],
      }, {
        name: 'Lisapaulin',
        title: translations[2][0],
        description: translations[3][0],
      }, {
        name: 'Basil S.',
        title: translations[4][0],
        description: translations[5][0],
      }, {
        name: 'Phil83s',
        title: translations[6][0],
        description: translations[7][0],
      }, {
        name: 'Manuel P.',
        title: translations[8][0],
        description: translations[9][0],
      },
    ];
  }],
  template,
})

.name;
